import type { ITabProps } from './Tab';
import { Tab } from './Tab';
import type { ITabPanelProps } from './TabPanel';
import { TabPanel } from './TabPanel';
import { default as TabsMain } from './Tabs';
import type { ITabsComponent, ITabsProps } from './Tabs.types';

const TabsTemp: any = TabsMain;
TabsTemp.TabPanel = TabPanel;
TabsTemp.Tab = Tab;

const Tabs: ITabsComponent = TabsTemp as ITabsComponent;

export { Tabs };

export type { ITabProps, ITabPanelProps, ITabsComponent, ITabsProps };
